import { Instance, types } from 'mobx-state-tree';

interface CgAssessmentPayload {
	assessment_title?: string | null;
	assessment_type?: string;
	[key: string]: unknown;
}

const CgAssessmentResult = types.model('CgAssessmentResult', {
	id: types.identifierNumber,
	user_id: types.maybeNull(types.number),
	type: types.string,
	name: types.maybeNull(types.string),
	status: types.maybeNull(types.string),
	kind: types.maybeNull(types.string),
	completed_at: types.maybeNull(types.string),
	payload: types.maybeNull(types.frozen<CgAssessmentPayload>()),
	created_at: types.maybeNull(types.string),
	updated_at: types.maybeNull(types.string),
});

export default CgAssessmentResult;

export interface ICgAssessmentResultModel extends Instance<typeof CgAssessmentResult> {}
